var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasualEncounterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0732 53.9852C55.0732 53.9852 55.3094 53.8165 55.6868 53.5281C61.3412 49.1561 64.8848 42.8206 64.8848 35.7672C64.8848 22.6176 52.5206 11.947 37.2786 11.947C22.0305 11.947 9.66016 22.6176 9.66016 35.7672C9.66016 48.923 22.0243 59.2254 37.2725 59.2254C38.5733 59.2254 40.7087 59.1395 43.6785 58.9677C47.5504 61.4835 53.2017 63.5483 58.1474 63.5483C59.6783 63.5483 60.3993 62.2904 59.4175 61.0079C57.9265 59.1794 55.8709 56.2494 55.0732 53.9822V53.9852Z",
    stroke: "#186D9A",
    strokeWidth: 6.13607,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4668 42.3511C31.1369 50.0212 43.409 50.0212 51.0791 42.3511",
    stroke: "#186D9A",
    strokeWidth: 6.13607,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.6328,
    height: 73.6328,
    fill: "white",
    transform: "translate(0.457031 0.932617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasualEncounterIcon);
export default __webpack_public_path__ + "static/media/casual-encounter-icon.db642103607f7d956bd5c9ea3e16b6cd.svg";
export { ForwardRef as ReactComponent };